import axios from 'axios';
import { type Payload } from '../model/Auth';

const AuthServices: any = {};

AuthServices.login = async function (data: Payload) {
  const login = await axios.post('/api/users/login', data, { withCredentials: true });
  return login;
};

export default AuthServices;
